import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { SuccessWrapComponent } from '../../../../common/components/success.wrap/success.wrap.component';
import { AccountApiService } from '../../../../services/account.api.service';
import { SetContactsModalData } from './set.contacts.modal.provider';
import { AlertifyService } from '../../../../services/alertify.service';

@Component({
  templateUrl: './set.contacts.modal.component.html',
  styleUrls: ['./set.contacts.modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SetContactsModalComponent extends BaseComponent {
  public hubContactsForm: FormGroup;
  public placeForm: FormGroup;

  public contact: {
    name: '';
    number: '';
    email: '';
    inquiryEmail: '';
    eventCalendarURL: '';
    placeCalendarURL: '';
    moreToursURL: '';
    placeURLs: { igURL; clientURL }[];
  };
  public account: SetContactsModalData;
  @ViewChild('success') public success: SuccessWrapComponent;

  constructor(
    private fb: FormBuilder,
    private accountApiService: AccountApiService,
    private alertify: AlertifyService,
    private dialogRef: MatDialogRef<SetContactsModalComponent>,
    data: SetContactsModalData
  ) {
    super();
    this.account = Object.assign({}, data);
    this.contact = this.account.account.contacts;
  }

  ngOnInit() {
    this.hubContactsForm = this.fb.group({
      name: [null, [Validators.required]],
      number: [null],
      email: [null, [Validators.required]],
      inquiryEmail: [null, null],
      event: [null, null],
      place: [null, null],
      tour: [null, null],
    });

    this.placeForm = this.fb.group({
      dynamicFields: this.fb.array([]),
    });

    for (const url of this.contact.placeURLs) {
      this.addPlaceURL(url.igURL, url.clientURL);
    }
  }

  close() {
    this.dialogRef.close();
  }

  public save(event: ButtonTriggerEvent) {
    const array = this.placeForm.get('dynamicFields') as FormArray;
    console.log(array);
    const urls = array.value.filter((x) => x.igURL && x.clientURL);
    const igDegaulePlaceCategories = [
      'All',
      'Accommodations',
      'Activities',
      'Arts & Culture',
      'Dining & Nightlife',
      'Entertainment',
      'Outdoors',
      'Wellness',
      'Shopping',
      'Transportation',
      'Other',
    ];

    for (const url of urls) {
      const regex = /\/places\/(\w+)\/custom/;
      const match = url.igURL.match(regex);
      if (!match && !igDegaulePlaceCategories.any((x) => x === url.igURL)) {
        this.alertify.warning(
          `ImGoing place URL must be ImGoing's default place category (
            ${igDegaulePlaceCategories.join(', ')}). 
            <br/><br/>Or custom category in this format: /${
              this.account.account.userName
            }/places/664b3fdcbf671088a01a8322/custom`,
          10
        );
        setTimeout(() => {
          const msgbox = document.querySelector('.ajs-message');
          if (msgbox) {
            (msgbox as HTMLElement).style.width = '450px';
            (msgbox as HTMLElement).style.right = '490px';
          }
        });
        event.immediateComplete();
        return;
      }
    }

    this.contact.placeURLs = urls;

    this.accountApiService
      .setContacts(this.account.account._id, this.contact)
      .finally(event.complete)
      .subscribe((data) => {
        this.success.success();

        setTimeout(() => {
          this.dialogRef.close();
        }, 2000);
      });
  }

  public addPlaceURL(igURL = '', clientURL = '') {
    const newGroup = this.fb.group({
      igURL: [igURL],
      clientURL: [clientURL],
    });
    (this.placeForm.get('dynamicFields') as FormArray).push(newGroup);
  }

  public getControls() {
    const field = this.placeForm.get('dynamicFields');
    if (field) {
      return (field as any).controls;
    }
    return [];
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/set.contacts/set.contacts.modal.component.ts